<script setup>
import { ref, computed } from 'vue'

const id1 = ref('')
const id2 = ref('')
const id3 = ref('')
const pin = ref('')
const progress = ref(false)

const id = computed( () => {
  return `${id1.value}-${id2.value}-${id3.value}`;
})

function checkAct() {
  progress.value = true
  document.location = `https://pin.poverkadoma.ru/up?id=${id.value}&pin=${pin.value}`;
  progress.value = false
}

</script>

<template>
<!--  <div class="wrapper min-vh-100 d-flex flex-row align-items-center">-->
    <CContainer>
      <CRow class="justify-content-center">
        <CCol :md="4" v-if="!progress">
          <CCardGroup>
            <CCard class="text-white bg-secondary">
              <CCardBody class="text-center">
                <CForm>
                  <h2>Поиск акта</h2>
                  <p>
                    введите номер акта и пин-код
                  </p>
                  <CInputGroup class="mb-3">
                    <CFormInput
                        type="number"
                        aria-valuemax="3"
                        v-model="id1"
                        placeholder="***"
                    />
                    <CFormInput
                        type="number"
                        size="2"
                        v-model="id2"
                        placeholder="**"
                    />
                    <CFormInput
                        type="number"
                        size="6"
                        v-model="id3"
                        placeholder="****"
                    />
                  </CInputGroup>
                  <CRow>
                    <CCol sm="2">
                    </CCol>
                    <CCol sm="8">
                      <CInputGroup class="mb-3">
                        <CFormInput
                            placeholder="пин-код"
                            type="number"
                            v-model="pin"
                        />
                      </CInputGroup>
                    </CCol>
                    <CCol sm="2">
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="12">
                        <CButton class="btn btn-dark" @click="checkAct"> Найти </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
        <CCol :md="4" v-else>
          Подождите, пожалуйста, идет поиск поверок...
        </CCol>
      </CRow>
      <br/>
      <AppFooter>
        <a href="http://lk.poverkadoma.ru" class="text-dark">Перейти в личный кабинет поверителя</a>
      </AppFooter>
    </CContainer>
<!--  </div>-->
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
